import styled from "styled-components";

interface InfoContainer {
  display: boolean;
}

export const MiniCardBox = styled.div<{ $isLocked?: boolean }>`
  width: 100%;
  height: 100%;
  background: var(--white);
  border: 1px solid rgba(0, 0, 0, 0.04);
  border-radius: 16px;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.03);
  position: relative;
  transition: all 0.2s ease;

  &:hover {
    transform: ${({ $isLocked }) => ($isLocked ? "none" : "translateY(-2px)")};
    box-shadow: ${({ $isLocked }) =>
      $isLocked
        ? "0px 4px 12px rgba(0, 0, 0, 0.03)"
        : "0px 8px 20px rgba(0, 0, 0, 0.06)"};
  }
`;

export const IconContainer = styled.div`
  background: rgba(152, 53, 209, 0.05); /* Soft purple background */
  color: var(--fixit);
  width: 52px;
  height: 52px;
  min-width: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    font-size: 24px;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  width: 100%;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const MiniHeader = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: var(--gray);
  line-height: 1.2;
`;

export const CardValue = styled.label`
  font-size: 32px;
  font-weight: 700;
  color: var(--fixit);
  line-height: 1;

  .dynamic-text-container {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const Info = styled.div<InfoContainer>`
  display: ${(props) => (props.display ? "flex" : "none")};
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 6px;
  margin: -6px 0 -6px 4px;
  opacity: 0.6;
  transition: opacity 0.2s;
  -webkit-tap-highlight-color: transparent;

  &:hover {
    opacity: 1;
  }

  svg {
    font-size: 16px;
    color: var(--gray);
  }
`;

